import React from 'react'
import SplashScreen from '../../assets/Images/splash.png'
import { Link } from 'react-router-dom'
import '../splash/Splash.css'

const Splash = ({ onClick }) => {
  return (
    <div className='splash-sec'  onClick={onClick}>
        <Link rel='stylesheet' to="/home" className='d-flex flex-wrap align-items-center justify-content-center'>
            <img src={SplashScreen} alt="" />
        </Link>
    </div>
  )
}

export default Splash
